import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    class: "login-form",
    id: "login-form"
};
const _hoisted_2 = { class: "login-form__title" };
const _hoisted_3 = { class: "alert alert--success" };
const _hoisted_4 = { class: "alert alert--success" };
const _hoisted_5 = { class: "alert alert--error" };
const _hoisted_6 = {
    key: 0,
    class: "alert alert--error"
};
const _hoisted_7 = {
    key: 1,
    class: "alert alert--error"
};
const _hoisted_8 = { class: "password-policy__errors" };
const _hoisted_9 = { class: "form__field-set" };
const _hoisted_10 = { class: "form__group form__group--required" };
const _hoisted_11 = { class: "form__label-wrapper" };
const _hoisted_12 = {
    for: "password_new",
    class: "form__label"
};
const _hoisted_13 = { class: "form__control-wrapper" };
const _hoisted_14 = {
    id: "password-requirements",
    class: "password-policy"
};
const _hoisted_15 = { class: "form__group form__group--required" };
const _hoisted_16 = { class: "form__label-wrapper" };
const _hoisted_17 = {
    for: "password_confirm",
    class: "form__label"
};
const _hoisted_18 = { class: "form__control-wrapper" };
const _hoisted_19 = { class: "form__buttons" };
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
    key: 0,
    class: "alert alert--error"
};
const _hoisted_22 = {
    key: 1,
    class: "alert alert--error"
};
const _hoisted_23 = {
    key: 2,
    class: "alert alert--error"
};
const _hoisted_24 = { class: "form__field-set" };
const _hoisted_25 = { class: "form__group form__group--required" };
const _hoisted_26 = { class: "form__label-wrapper" };
const _hoisted_27 = {
    for: "username",
    class: "form__label"
};
const _hoisted_28 = { class: "form__control-wrapper" };
const _hoisted_29 = { class: "form__buttons" };
const _hoisted_30 = ["disabled"];
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import paloma from '@astina/paloma-common-ui/src/services/PalomaBackend';
import { DEFAULT_PASSWORD_POLICY } from '@astina/paloma-common-ui/src/services/AppEnv';
import env from '../services/AppEnv';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoginResetPasswordView',
    setup(__props) {
        const route = useRoute();
        const { t, te } = useI18n();
        // What the server enforces. Advisory here: the checks below only spare the user a
        // round trip, a password the server rejects still surfaces as passwordErrors.
        const policy = computed(() => env.security.passwordPolicy ?? DEFAULT_PASSWORD_POLICY);
        const rules = computed(() => {
            const p = policy.value;
            const items = [{
                    code: 'password.too_short',
                    label: t('login.password-policy.min-length', { min: p.minLength }),
                    params: { minLength: p.minLength },
                    isSatisfiedBy: password => password.length >= p.minLength,
                }];
            if (p.requireLowerCase) {
                items.push({
                    code: 'password.missing_lower_case',
                    label: t('login.password-policy.lower-case'),
                    isSatisfiedBy: password => /\p{Ll}/u.test(password),
                });
            }
            if (p.requireUpperCase) {
                items.push({
                    code: 'password.missing_upper_case',
                    label: t('login.password-policy.upper-case'),
                    isSatisfiedBy: password => /\p{Lu}/u.test(password),
                });
            }
            if (p.requireDigit) {
                items.push({
                    code: 'password.missing_digit',
                    label: t('login.password-policy.digit'),
                    isSatisfiedBy: password => /\d/.test(password),
                });
            }
            if (p.requireSpecialCharacter) {
                items.push({
                    code: 'password.missing_special_character',
                    label: t('login.password-policy.special-character'),
                    isSatisfiedBy: password => !/^[\p{L}\p{N}]*$/u.test(password),
                });
            }
            return items;
        });
        const passwordErrors = ref([]);
        const emailAddress = ref('');
        const passwordNew = ref('');
        const passwordConfirm = ref('');
        // the password that is actually validated and sent
        const enteredPassword = computed(() => passwordNew.value.trim());
        const requirements = computed(() => rules.value.map(rule => ({
            code: rule.code,
            label: rule.label,
            satisfied: rule.isSatisfiedBy(enteredPassword.value),
        })));
        const token = ref(null);
        const invite = ref(false);
        const loading = ref(false);
        const started = ref(false);
        const success = ref(false);
        const error = ref(false);
        const emailNotFound = ref(false);
        const userDisabled = ref(false);
        const expired = ref(false);
        onMounted(onRouteChange);
        watch(() => route.query, onRouteChange);
        function onRouteChange() {
            resetState();
            // @ts-ignore
            token.value = route.query.token;
            // @ts-ignore
            emailAddress.value = route.query.email || route.query.emailAddress || '';
            // @ts-ignore
            invite.value = !!route.query.invite;
            if (token.value) {
                loading.value = true;
                paloma
                    .execute('customers.get-password-reset-token', {
                    token: token.value,
                })
                    .catch(() => expired.value = true)
                    .finally(() => loading.value = false);
            }
        }
        function start() {
            const emailAddressLocal = emailAddress.value.trim();
            if (!emailAddressLocal) {
                return;
            }
            resetState();
            loading.value = true;
            paloma
                .execute('customers.start-password-reset', {
                emailAddress: emailAddressLocal,
            })
                .then(() => {
                started.value = true;
            })
                .catch(e => {
                if (e.errors && e.errors[0].property === 'emailAddress' && e.errors[0].code === 'invalid') {
                    emailNotFound.value = true;
                }
                else if (e.errors && e.errors[0].property === 'status' && e.errors[0].code === 'disabled') {
                    userDisabled.value = true;
                }
                else {
                    error.value = true;
                }
            })
                .finally(() => loading.value = false);
        }
        function reset() {
            const passwordNewLocal = enteredPassword.value;
            const passwordConfirmLocal = passwordConfirm.value.trim();
            if (!passwordNewLocal) {
                return;
            }
            resetState();
            const violations = checkPolicy(passwordNewLocal);
            if (violations.length) {
                passwordErrors.value = violations;
                return;
            }
            loading.value = true;
            paloma
                .execute('customers.finish-password-reset', {
                token: token.value,
                passwordNew: passwordNewLocal,
                passwordConfirm: passwordConfirmLocal,
            })
                .then(() => {
                success.value = true;
            })
                .catch(e => {
                const errors = e.errors || [];
                const passwordError = errors.find(v => v.property === 'password');
                if (passwordError) {
                    // The server enforces the policy and may be stricter than the form.
                    passwordErrors.value = [messageFor(passwordError)];
                }
                else if (errors[0] && errors[0].property === 'token' && errors[0].code === 'invalid') {
                    expired.value = true;
                }
                else {
                    error.value = true;
                }
            })
                .finally(() => loading.value = false);
        }
        /**
         * Mirrors PasswordPolicyCheck on the server
         */
        function checkPolicy(password) {
            const violations = rules.value
                .filter(rule => !rule.isSatisfiedBy(password))
                .map(rule => messageFor(rule));
            if (password.length > policy.value.maxLength) {
                violations.push(messageFor({
                    code: 'password.too_long',
                    params: { maxLength: policy.value.maxLength },
                }));
            }
            return violations;
        }
        function messageFor(violation) {
            const key = 'login.password-policy.error.' + (violation.code || 'invalid');
            // params carry the limit that was missed (minLength / maxLength)
            if (te(key)) {
                return t(key, violation.params || {});
            }
            // an unknown code means the server checks something this UI does not know about
            return violation.message || t('login.password-policy.error.invalid');
        }
        function resetState() {
            loading.value = false;
            success.value = false;
            error.value = false;
            passwordErrors.value = [];
            emailNotFound.value = false;
            userDisabled.value = false;
            expired.value = false;
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            const _component_icon = _resolveComponent("icon");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(invite.value ? 'login.set-password' : 'login.password-reset')), 1),
                _cache[21] || (_cache[21] = _createTextVNode()),
                (started.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('login.password-reset-started')), 1),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("p", null, [
                            _createVNode(_component_router_link, {
                                to: { name: 'login_form' },
                                class: "button button--link button--cancel"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ], 64))
                    : (success.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('login.password-reset-success')), 1),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("p", null, [
                                _createVNode(_component_router_link, {
                                    to: { name: 'login_form' },
                                    class: "button button--link button--cancel"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                    ]),
                                    _: 1
                                })
                            ])
                        ], 64))
                        : (expired.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('login.password-reset-token-error')), 1),
                                _cache[7] || (_cache[7] = _createTextVNode()),
                                _createElementVNode("p", null, [
                                    _createVNode(_component_router_link, {
                                        to: { name: 'login_reset_password' },
                                        class: "button button--link button--cancel"
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                        ]),
                                        _: 1
                                    })
                                ])
                            ], 64))
                            : (token.value)
                                ? (_openBlock(), _createElementBlock("form", {
                                    key: 3,
                                    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event) => (reset()), ["prevent"])),
                                    class: "form form--simple"
                                }, [
                                    (error.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('login.password-reset-invalid')), 1))
                                        : _createCommentVNode("", true),
                                    _cache[12] || (_cache[12] = _createTextVNode()),
                                    (passwordErrors.value.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            _createElementVNode("ul", _hoisted_8, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(passwordErrors.value, (message) => {
                                                    return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1));
                                                }), 128))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true),
                                    _cache[13] || (_cache[13] = _createTextVNode()),
                                    _createElementVNode("fieldset", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, [
                                                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t(invite.value ? 'login.password' : 'login.password-new')), 1)
                                            ]),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_13, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((passwordNew).value = $event)),
                                                    type: "password",
                                                    name: "password_new",
                                                    class: "form__control",
                                                    id: "password_new",
                                                    tabindex: "1",
                                                    required: "",
                                                    "aria-describedby": "password-requirements"
                                                }, null, 512), [
                                                    [_vModelText, passwordNew.value]
                                                ])
                                            ])
                                        ]),
                                        _cache[10] || (_cache[10] = _createTextVNode()),
                                        _createElementVNode("ul", _hoisted_14, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requirements.value, (requirement) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: requirement.code,
                                                    class: _normalizeClass(["password-policy__item", { 'password-policy__item--satisfied': requirement.satisfied }])
                                                }, [
                                                    _createVNode(_component_icon, {
                                                        name: requirement.satisfied ? 'check' : 'circle',
                                                        class: "password-policy__marker"
                                                    }, null, 8, ["name"]),
                                                    _createTextVNode(" " + _toDisplayString(requirement.label), 1)
                                                ], 2));
                                            }), 128))
                                        ]),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('login.password-confirm')), 1)
                                            ]),
                                            _cache[9] || (_cache[9] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((passwordConfirm).value = $event)),
                                                    type: "password",
                                                    name: "password_confirm",
                                                    class: "form__control",
                                                    id: "password_confirm",
                                                    tabindex: "1",
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, passwordConfirm.value]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _cache[14] || (_cache[14] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_19, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            disabled: loading.value,
                                            class: "button button--primary",
                                            tabindex: "2"
                                        }, [
                                            _createVNode(_component_icon, { name: "redo" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t(invite.value ? 'login.set-password' : 'login.password-reset')), 1)
                                        ], 8, _hoisted_20)
                                    ])
                                ], 32))
                                : (_openBlock(), _createElementBlock("form", {
                                    key: 4,
                                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (start()), ["prevent"])),
                                    class: "form form--simple"
                                }, [
                                    (error.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.$t('login.password-reset-failed')), 1))
                                        : _createCommentVNode("", true),
                                    _cache[17] || (_cache[17] = _createTextVNode()),
                                    (emailNotFound.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('login.password-reset-email-not-found')), 1))
                                        : _createCommentVNode("", true),
                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                    (userDisabled.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.$t('login.password-reset-user-disabled')), 1))
                                        : _createCommentVNode("", true),
                                    _cache[19] || (_cache[19] = _createTextVNode()),
                                    _createElementVNode("fieldset", _hoisted_24, [
                                        _createElementVNode("div", _hoisted_25, [
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('login.email')), 1)
                                            ]),
                                            _cache[15] || (_cache[15] = _createTextVNode()),
                                            _createElementVNode("div", _hoisted_28, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((emailAddress).value = $event)),
                                                    type: "email",
                                                    name: "email",
                                                    class: "form__control",
                                                    id: "username",
                                                    tabindex: "1",
                                                    required: ""
                                                }, null, 512), [
                                                    [_vModelText, emailAddress.value]
                                                ])
                                            ])
                                        ])
                                    ]),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("button", {
                                            type: "submit",
                                            disabled: loading.value,
                                            class: "button button--primary",
                                            tabindex: "2"
                                        }, [
                                            _createVNode(_component_icon, { name: "redo" }),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('login.password-reset')), 1)
                                        ], 8, _hoisted_30),
                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                        _createVNode(_component_router_link, {
                                            to: { name: 'login_form' },
                                            class: "button button--link button--cancel",
                                            tabindex: "3"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ], 32))
            ]));
        };
    }
});
